export enum BusinessRepresentativeInteraction {
  PROMOTE,
  DELETE_REPRESENTATIVE,
  DELETE_INVITE,
  RESEND_INVITE,
}
